module.exports = __webpack_public_path__ + "img/mingcheng.da97d9f9.png";